import { PRODUCT_STATUSES } from "api/memberPortal/project/product/productStatuses.type";

import { PineFilters } from "./Pine.schema";

const initialPineFilters: PineFilters = {
  // strings
  productName: "",
  v_id: "",
  vendor: "",
  lab: "",
  progressPoint: [],

  // booleans (empty string for clearable radio groups)
  csfcEligible: "",
  dodCompliant: "",
  kickoffStatus: "",
  postingRecommended: "",
  isResubmission: "",
  acmrApproval: "",

  // dates
  dynamicDate: { after: undefined, before: undefined, field: "" },

  // string arrays
  status: [
    PRODUCT_STATUSES.PROPOSED,
    PRODUCT_STATUSES.PRE_EVALUATION,
    PRODUCT_STATUSES.IN_PROGRESS,
    PRODUCT_STATUSES.FINALIZING,
    PRODUCT_STATUSES.IN_ASSURANCE_MAINTENANCE,
  ],

  // protection profiles
  ppClaims: [],
  conformanceType: "any",
};

export default initialPineFilters;
